import debounce from 'lodash.debounce';
import { action, observable } from 'mobx';

import { MOBILE_MODE_WIDTH_THRESHOLD } from '../ui/mobile/constant';

/**
 * UI Store is the intended place where we keep track of all UI-specific state.
 * For example:
 *  - the width of the browser / whether we should trigger mobile mode
 *  - Whether drawer is opened
 *  - Whether page blanket should be triggered
 *
 * This store ABSOLUTELY should not contain any user data.
 */

export default class UIStore {
  @observable mobileMode: boolean = false;

  setOnMobileMode = debounce((width: number) => {
    if (!this.mobileMode && width <= MOBILE_MODE_WIDTH_THRESHOLD) {
      this.enableMobileMode();
    } else if (this.mobileMode && width > MOBILE_MODE_WIDTH_THRESHOLD) {
      this.disableMobileMode();
    }
  });

  @action
  disableMobileMode() {
    this.mobileMode = false;
  }

  @action
  enableMobileMode() {
    this.mobileMode = true;
  }
}
